// import logo from './logo.svg';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { Cookies, useCookies } from 'react-cookie';
import { Header } from './Header/header';
import { Footer } from "./Footer/footer";
import { Invoice } from "./Invoice/invoice";
import { Login } from "./Login/login";
import { Signup } from "./Signup/signup";
import { PasswordReset } from "./PasswordReset/passwordReset";
import { Contact } from "./Help/contact";
import { fetchLogin} from './API/apiservice';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  const [storeList, setStoreList] = useState([]);
  // const [cookies, setCookie] = useCookies(['user']);
  const cookies = new Cookies();
  const [isLoggedIn, setIsLoggedIn] = useState(cookies.get('email') && cookies.get('email') != "undefined");
  // const [userData, setUserData] = useState({email: '', custNum: ''});
  // const  navigate= useNavigate();

  useEffect(() => {
    validateCookies();
  }, []
  )

  const validateCookies = () => {
    // if (!cookies.get('email') || cookies.get('email') == "undefined" || !cookies.get('customerNumber') || cookies.get('customerNumber') == "undefined") {
      if (!cookies.get('email') || cookies.get('email') == "undefined") {
      setIsLoggedIn(false);
      return false;
    }
    else {
      setIsLoggedIn(true);
      return true;
      // setCookie('Email', cookies.Email, { path: '/' });
      // setCookie('FirstName', cookies.FirstName, { path: '/' });
      // setCookie('Sites', cookies.Sites, { path: '/' });
      // if(cookies.SiteSelected == undefined  || cookies.SiteSelected == "") {
      //   setCookie('SiteSelected', cookies.Sites[0], { path: '/' });
      // }
      // else setCookie('SiteSelected', cookies.SiteSelected, { path: '/' });
      // setLoginData(true);
    }
  }

  return (
    <BrowserRouter>
      <div className="App">
        <div className='appbg'>
          <Header  validateCookies={validateCookies}/>
          <div id="body" className="row">
            {
              isLoggedIn ? 
              <Routes>
                {/* <Route index path="/app/" element={<Invoice validateCookies={validateCookies} />} /> */}
                <Route index path="/app/" element={<Navigate to="/app/invoice" />} />
                <Route path="app/invoice" element={<Invoice validateCookies={validateCookies} storeList={storeList}/>} />
                <Route path="app/contact" element={<Contact/>} />
                <Route path="*" element={<Navigate to="/app/invoice" />} />
                {/* <Route path="statement" element={<Statement />} />
                <Route path="dashboard" element={<Dashboard />} /> */}
              </Routes>
            :
              <Routes>
                {/* <Route index path="/" element={<Login />} /> */}
                <Route path="app/login" element={<Login setIsLoggedIn={setIsLoggedIn} setStoreList={setStoreList}/>} />
                <Route path="*" element={<Navigate to="app/login" />} />
                <Route path="app/signup" element={<Signup />} />
                <Route path="app/passwordReset" element={<PasswordReset />} />
                <Route path="app/passwordReset/:guid" element={<PasswordReset setIsLoggedIn={setIsLoggedIn} />} />
                {/* <Route path="invoice" element={<Invoice />} /> */}
                {/* <Route path="statement" element={<Statement />} />
                <Route path="dashboard" element={<Dashboard />} /> */}
              </Routes>
            }
          </div>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
